import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { getConfectioneryDetail } from "../../utils/confectioneryManager";
import { useCheckoutStore } from "../../store/useCheckoutStore";
import { userStore } from "../../store/userStore";
import Confectionery from "../Confectionery/Confectionery.jsx";
import ConfectioneryProductModal from "../ConfectioneryProductModal/ConfectioneryProductModal.jsx";
import { useVizionarioStore } from "../../store/useVizionarioStore.js";

Confectioneries.propTypes = {
  confectioneries: PropTypes.object,
  setShowCheckout: PropTypes.func,
};

export default function Confectioneries({ setShowCheckout }) {
  const isAval = useVizionarioStore((state) => state.isAval);

  const { confectioneries, confectioneries_api } = useCheckoutStore();
  const { userMembershipStatus: membership } = userStore();
  const [modalOpen, setModalOpen] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [currentProductApi, setCurrentProductApi] = useState(null);
  const [listConfectionery, setListConfectionery] = useState([]);

  useEffect(() => {
    if (confectioneries && membership) {
      let confectioneriesAval = confectioneries["Lista_Productos"].filter(
        (confectionery) => confectionery.CineFanPlus.toLowerCase() === "s"
      );
      let confectioneriesGeneral = confectioneries["Lista_Productos"].filter(
        (confectionery) => confectionery.CineFanPlus.toLowerCase() !== "s"
      );
      setListConfectionery(
        isAval ? confectioneriesAval : confectioneriesGeneral
      );
    } else if (confectioneries) {
      let confectioneriesGeneral = confectioneries["Lista_Productos"].filter(
        (confectionery) => confectionery.CineFanPlus.toLowerCase() !== "s"
      );
      setListConfectionery(confectioneriesGeneral);
    }
  }, [confectioneries, membership]);

  const onSelectProduct = (product, productApi) => {
    setCurrentProduct(product);
    setCurrentProductApi(productApi);
    setModalOpen(true);
  };
  return (
    <>
      {currentProduct !== null && (
        <ConfectioneryProductModal
          modalOpen={modalOpen}
          currentProduct={currentProduct}
          currentProductApi={currentProductApi}
          onCloseModal={() => setModalOpen(false)}
          setShowCheckout={setShowCheckout}
        />
      )}
      <div className="showtimeDetail-confectioneries row w-100">
        {listConfectionery.map((confectionery) => {
          const productApi = getConfectioneryDetail(
            confectionery.Codigo,
            confectioneries_api
          );
          if (!productApi) return null;
          return (
            <div
              className="showtimeDetail-confectionery col-md-4 col-6"
              key={confectionery.Codigo}
            >
              <Confectionery
                confectionery={productApi}
                product={confectionery}
                onSelected={onSelectProduct}
                key={confectionery.Codigo}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
